export default "__VITE_ASSET__Ck6aGrT7__"